import React from "react";

import emptyRole from "assets/images/manageTeam/EmptyRole.png";

import "./emptyRole.scss";
import Button from "components/Button/index";

function EmptyRole({ handleModal }) {
  return (
    <div className="EmptyRole">
      <div className="EmptyRoleContainer">
        <div className="EmptyRoleTop">
          <img src={emptyRole} alt="empty" />
        </div>
        <div className="EmptyRoleWrapper">
          <h1>Create Role</h1>
          <p>Use the add button to Create a new Role</p>
        </div>
        <Button title="+ Add Role" type="violet" onClick={handleModal} />
      </div>
    </div>
  );
}

export default EmptyRole;
